import { IAppReduxState } from 'shared/types/app';

export function selectIsOpen(state: IAppReduxState): boolean {
  return state.Warning.isOpen;
}

export function selectMessage(state: IAppReduxState): string {
  return state.Warning.message;
}
